export default async ({ store, app: { $config } }) => {
    await store.dispatch('checkout/setGateway', $config.paymentGateway);
};
